import React, {useEffect, useState} from 'react';
import SessionStore from "../../../../services/session/SessionStore";
import ContentEditor from "../../manageTemplates/ContentEditor";
import {loadLocalPagesTemplates, localPagesBrands, localPagesContents} from "./LocalPagesApi";


function BulkLocationEditorLocalPages({
                                          setFormIsInvalid,
                                          singleLocationMode,
                                          selectedLocations,
                                          locationPatch,
                                          accountStore,
                                          locationIds,
    setFormIsDirty
}) {

    const accountId = SessionStore.account.accountId;
    const [localPagesTemplateList, setLocalPagesTemplateList] = useState(null)
    const [localPagesContentList, setLocalPagesContentList] = useState(null)
    const [localPagesBrandList, setLocalPagesBrandList] = useState(null)

    console.log("locationIds", locationIds)
    console.log("selectedLocations", selectedLocations)

    useEffect(() => {
        loadLocalPagesTemplates(0, 100, accountId)
            .then(data => {
                setLocalPagesTemplateList(data || [])
            })
    }, []) // pass in an empty array means "this function has no dependencies, just run it the one time". Otherwise when dependencies change between renders, the function will be called again


    useEffect(() => {
        localPagesContents(0, 100, locationIds, [], [])
            .then(data => {
                setLocalPagesContentList(data || [])
            })
    }, [])

    useEffect(() => {
        localPagesBrands({offset: 0, limit: 100, accountIds: [accountId]}).then(data => {
            setLocalPagesBrandList(data || [])
        })
    }, [])


    const loaded = (localPagesContentList != null) && (localPagesTemplateList != null) && (localPagesBrandList != null)

    return (<div>

            {!loaded && <div className="text-center">
                <h4 className="admin-update-status">Loading</h4><i className="fa fa-spinner fa-spin fa-2x"></i>
            </div>
            }

            {loaded && <ContentEditor
                locationIds={locationIds}
                singleLocationMode={singleLocationMode}
                locationPatch={locationPatch}
                localPagesContentList={localPagesContentList}
                localPagesTemplateList={localPagesTemplateList}
                localPagesBrandList={localPagesBrandList}
                selectedLocations={selectedLocations}
                setFormIsDirty={setFormIsDirty}
            />

            }

        </div>
    )

}

export default BulkLocationEditorLocalPages;